import React from 'react';
import {Divider, Typography} from "@material-ui/core";
import CustomGrid from "../../containers/Grid/CustomGrid";
import CustomBox from "../../containers/Box/CustomBox";
import CustomCard from "../../containers/Card/CustomCard";
import AccordionForm from "../../containers/Accordion/AccordionForm";
import DynamicValue from "../../containers/DataTable/DynamicTable/DynamicValue";
import PesonnelRoleForm from "./Form/PesonnelRoleForm";

const header = (fields) => {

  return (
    <CustomGrid auto={false}>
      <CustomBox className={'noMargin'} direction={'column'}>
        <Typography variant={'body2'}>
          Role: <DynamicValue type={'render|role'} value={fields.role_id}/>
        </Typography>
        <Typography variant={'body2'}>
          Start Date: <DynamicValue type={'date'} value={fields.start_date}/>
          {' '}
          End Date: <DynamicValue type={'date|no_expiry'} value={fields.end_date}/>
        </Typography>
      </CustomBox>
      <CustomBox className={'noMargin'} align={'right'}>
        <DynamicValue type={'render|status'} value={fields.status_id}/>
      </CustomBox>
    </CustomGrid>

  )
}

const PesonnelRoleItems = (props) => {
  const {fields, uid, personnelId, sectionCrudAllowed} = props;

  return (
    <CustomCard
      variant={'outlined'}
    >
      <AccordionForm
        header={header(fields)}
        addButton={true}
        title={'Personnel'}
        form={<PesonnelRoleForm data={{}} personnelId={personnelId} uid={uid} sectionCrudAllowed={sectionCrudAllowed}/>}
      >
        <Divider/>
        <PesonnelRoleForm data={fields} id={fields.id} uid={uid} personnelId={personnelId} sectionCrudAllowed={sectionCrudAllowed}/>
      </AccordionForm>
    </CustomCard>
  )
}

export default PesonnelRoleItems;